export * from './ipad-payment-type'
